import Router from "vue-router";
import Vue from "vue";
import routes from "./pages/routes";

Vue.use(Router);

export default new Router({
  routes,
});
